<div class="">
  <div class="row">
    <div class="col-8">
      <img [src]="captchaImage">
    </div>
  </div>

  <div class="row">
    <div class="col-8">
      <label for="captchatext">Please select six letters and numbers (A-Z, 1-9) that stand out from the others
        (not grey) and are touched by the line.</label>
    </div>
  </div>

  <div class="row">
    <div class="col-3 captcha-text">
      <div class="k-form-field">
        <input #captchainputfocus type="text" class="form-control" (input)="onInput($event)" name="captchatext"
          id="captchatext" toUppperCase placeholder="Enter Captcha Text*" (blur)="onBlur()" [value]="captchaText" />
        <!-- <input #captchainputfocus type="text" class="form-control" [(ngModel)]="captchaText" (input)="onInput($event)"
          name="captchatext" id="captchatext" toUppperCase placeholder="Enter Captcha Text*" /> -->
      </div>
    </div>
    <div class="col-2 offset-3 captcha-button">
      @if(disableButton){
      <button class="btn btn-primary" [disabled]="true">
        <fa-icon [icon]="['fat', 'sync']" [animation]="spinOptions"></fa-icon> Captcha
      </button>
      } @else {
      <button class="btn btn-primary" (click)="refreshCaptcha()" title="Refresh Captcha">
        <fa-icon [icon]="['fat', 'arrow-rotate-right']"></fa-icon> Captcha
      </button>
      }
      <!-- <button class="btn btn-primary" (click)="refreshCaptcha()">
        <fa-icon [icon]="['fat', 'arrow-rotate-right']"></fa-icon> Captcha
      </button> -->
    </div>
  </div>
  <!-- <div class="row">
    Metadata:<br>
    text: {{captchaText}}<br>
    touched: {{touched}}<br>
  </div> -->
</div>
